import { isBrowser } from '@atomixdesign/rem-scaling'

/**
 * Records a FAQ view by pinging the server-side proxy, which forwards to the
 * CMS View Count plugin. Fire-and-forget — errors are swallowed so tracking
 * never affects the UI. `keepalive` lets the request survive navigation.
 */
export const trackFaqView = (id?: string | null): void => {
  if (!isBrowser() || !id) {
    return
  }

  try {
    void fetch('/api/faq-view', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id }),
      keepalive: true,
    }).catch(() => {})
  } catch {
    // Ignore — a tracking failure must not break FAQ interactions.
  }
}
